import React from 'react'
import { Link } from 'react-router-dom'
import { Screen } from '../../components/lease/Screen'
import { BrandHeading } from '../../components/lease/BrandHeading'

// Mockup "5d Terms Declined Screen".
function TermsDeclined() {
  return (
    <Screen className="flex min-h-screen flex-col items-center justify-center text-center">
      <BrandHeading className="animate-fade-in text-4xl">Terms Declined</BrandHeading>
      <div className="mt-6 w-full animate-slide-in rounded-2xl bg-white/70 p-5 shadow-sm ring-1 ring-emerald-100 backdrop-blur dark:bg-slate-800/60 dark:ring-slate-700">
        <p className="text-slate-700 dark:text-slate-200">
          LeaseCheck needs your agreement to the Terms of Service, Disclaimer, and Refund
          Policy before we can analyze your lease. Without it, we can’t provide the service.
        </p>
        <p className="mt-4 text-sm text-slate-600 dark:text-slate-300">
          Questions? Reach us at{' '}
          <a className="text-emerald-700 underline dark:text-emerald-400" href="mailto:support@coloradoleasecheck.com">
            support@coloradoleasecheck.com
          </a>
        </p>
      </div>
      <div className="mt-8 flex w-full animate-slide-in flex-col gap-3">
        <Link
          to="/"
          className="w-full transform rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 py-4 text-lg font-bold text-white shadow-lg transition hover:-translate-y-0.5 hover:from-emerald-700 hover:to-teal-700 hover:shadow-xl"
        >
          Exit App
        </Link>
        <Link
          to="/legal"
          className="w-full rounded-xl bg-white py-4 text-lg font-bold text-emerald-700 ring-1 ring-emerald-200 transition hover:bg-emerald-50 dark:bg-slate-800/60 dark:text-emerald-400 dark:ring-slate-700"
        >
          Go Back
        </Link>
      </div>
    </Screen>
  )
}

export default TermsDeclined
